import { createBlock, openBlock, unref, withCtx, createElementVNode, renderSlot } from "vue";
import { DtInput } from "@dialpad/dialtone-vue";
import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
const _hoisted_1 = { class: "d-input__label-text d-label--sm" };
const __default__ = {
  name: "DtcControlSlot"
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    value: {
      type: void 0,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: [VALUE_UPDATE_EVENT],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    function updateValue(e) {
      const value = e || null;
      emit(VALUE_UPDATE_EVENT, value);
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(DtInput), {
        value: __props.value,
        disabled: __props.disabled,
        spellcheck: "false",
        size: "sm",
        onInput: updateValue
      }, {
        labelSlot: withCtx(() => [
          createElementVNode("span", _hoisted_1, [
            renderSlot(_ctx.$slots, "default")
          ])
        ]),
        _: 3
      }, 8, ["value", "disabled"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=control_slot.vue.js.map
